module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('md-tabs', {
    staticClass: "md-primary",
    attrs: {
      "md-centered": "",
      "md-elevation": "1"
    },
    on: {
      "change": _vm.onAreaChangeDelegate
    }
  }, _vm._l((_vm.certificationProcess.areas), function(area, tabindex) {
    return _c('md-tab', {
      key: tabindex,
      staticStyle: {
        "overflow-wrap": "break-word"
      },
      attrs: {
        "id": ("tab-" + tabindex),
        "md-label": area.name,
        "md-active": (tabindex === _vm.activeIndex)
      }
    }, [_c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [_c('span', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(area.name))]), _vm._v(" "), (area.description && area.description.trim().length > 0) ? _c('span', {
      staticClass: "caption"
    }, [_c('b', [_vm._v("Informações adicionais:")]), _vm._v(" " + _vm._s(area.description) + ".")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v("Adicione os equipamentos existentes na área.")])]), _vm._v(" "), _c('md-list', _vm._l((area.structures), function(structure, index) {
      return _c('md-list-item', {
        key: index
      }, [_c('div', {
        staticClass: "md-list-text-container"
      }, [_c('span', [_vm._v(_vm._s(structure.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(structure.description))])]), _vm._v(" "), (area.status !== 2) ? _c('md-button', {
        staticClass: "md-icon-button md-list-action",
        on: {
          "click": function($event) {
            return _vm.onEditStructure(index)
          }
        }
      }, [_c('md-icon', {
        staticClass: "md-primary"
      }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('md-divider', {
        staticClass: "md-inset"
      })], 1)
    }), 1), _vm._v(" "), (area.status === 2) ? _c('p', {
      staticClass: "md-warn md-center"
    }, [_c('md-icon', [_vm._v("warning")]), _vm._v(" "), _c('b', [_vm._v("ATENÇÃO:")]), _vm._v("\n        NÃO É POSSÍVEL ALTERAR OU EDITAR AS INFORMAÇÕES DESTA ÁREA APÓS A\n        SINCRONIZAÇÃO DAS FOTOS.\n      ")], 1) : _c('p', {
      staticClass: "no-equipments"
    }, [_c('md-button', {
      staticClass: "md-raised md-primary",
      on: {
        "click": function($event) {
          return _vm.addStructure()
        }
      }
    }, [_vm._v("ADICIONAR EQUIPAMENTO\n        ")])], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-row": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [(tabindex !== 0) ? _c('md-button', {
      staticClass: "md-accent md-dense",
      on: {
        "click": function($event) {
          return _vm.prevArea(tabindex)
        }
      }
    }, [_c('span', [_c('md-icon', {
      staticClass: "md-accent"
    }, [_vm._v("arrow_left")]), _vm._v("ÁREA ANTERIOR")], 1)]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [(_vm.certificationProcess.areas.length > 1 &&
      tabindex !== _vm.certificationProcess.areas.length - 1) ? _c('md-button', {
      staticClass: "md-accent md-dense",
      on: {
        "click": function($event) {
          return _vm.nextArea(tabindex)
        }
      }
    }, [_c('span', [_vm._v("PRÓXIMA ÁREA "), _c('md-icon', {
      staticClass: "md-accent"
    }, [_vm._v("arrow_right")])], 1)]) : _vm._e()], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('addStructureDialog', {
    ref: "add_structure_dialog",
    attrs: {
      "activeProcess": _vm.certificationProcess
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01657ee8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/StructureView.vue
// module id = 821
// module chunks = 1